import News from "./template-news";

const TaxCategory = {
  init() {
    News.init();
  },
};

export default TaxCategory;
